/**  Bypassing invites: The sign up code returned should have 8 characters */
export const signUpCodeNumberOfCharacters = 8;
